import styled from 'styled-components';

export const ComponentRender = styled.span`
  &:hover {
    .action-container {
      display: flex;
    }
  }

  .input-fields {

  }
`;

export const DivOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export const ActionContainer = styled.div`
  display: flex;
  width: 100%;
  position: absolute;
  bottom: 0;
  z-index: 2;
  justify-content: ${props => {
    const ref = {
      left: 'flex-start',
      center: 'center',
      right: 'flex-end',
    };

    return props.alignment in ref ? ref[props.alignment] : 'flex-start';
  }};

  .action-wrapper {
    display: flex;
    flex-direction: column;

    .link-edit-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      flex-direction: row;
      margin-bottom: -10px;

      input {
        margin: 0;
        padding: 5px 10px;
        font-size: 1.6rem;
        box-sizing: border-box;
      }

      button {
        padding: 5px;
        margin: 0;
        height: 40px;
        border: 1px solid #eee;

        i {
          margin-top: 5px;
        }
      }
    }

    .options-wrapper {
      display: flex;
      flex-direction: row;
      padding: 20px;

      .options {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px 30px;
        font-size: 1.6rem;
        border: 1px solid #eee;
        cursor: pointer;
        background: #fff;

        &:hover, &.selected {
          background-color: #eee;
        }

        &:first-child {
          border-top-left-radius: 3px;
          border-bottom-left-radius: 3px;
        }

        &:last-child {
          border-top-right-radius: 3px;
          border-bottom-right-radius: 3px;
        }
      }
    }
  }
`;